import spaceHeader from './spaceHeader.vue'
export default spaceHeader